import { Component } from '@angular/core';
import { faUserCircle } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { BrickCategory } from 'src/app/samwebDescription/samweb/brickCategoryType';
import { UserStatusBrickSettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/user-status-brick-settings/user-status-brick-settings.state';
import { SamwebBrick } from '../../samweb-brick.decorator';
import { UserStatusBrickSettingsComponent } from './user-status-brick-settings/user-status-brick-settings.component';
import { UserStatusBrickBaseComponent } from './user-status-brick.base.component';
import { UserStatusBrickSmallComponent } from './user-status-brick.small.component';

@Component({
   selector: 'samweb-user-status-brick-default',
   templateUrl: './user-status-brick.default.component.html',
   styleUrls: ['./user-status-brick.component.scss'],
})
@SamwebBrick({
   brickDefinitionId: 'userStatusBrick',
   brickTitleTranslationKey: 'brick.brick_definitions.user-status-brick.title',
   brickDescriptionTranslationKey: 'brick.brick_definitions.user-status-brick.description',
   brickIcon: faUserCircle,
   minColWidth: 10,
   minRowHeight: 2,
   collapsedRowHeight: 8,
   brickCategory: BrickCategory.GENERAL,
   settingsComponent: UserStatusBrickSettingsComponent,
   settingStateHandler: UserStatusBrickSettingsState,
   smallBrickComponentAlternative: UserStatusBrickSmallComponent,
   requiresActiveCoreConnection: true,
})
export class UserStatusBrickDefaultComponent extends UserStatusBrickBaseComponent {
   constructor(store: Store) {
      super(store);
   }
}
